import React from "react";

function FooterBlue() {
  return (
    <footer className="bg-[#27374D] text-[#DDE6ED] font-semibold p-4 w-screen">
      <div className="container mx-auto text-center">
        <p>&copy; Harsh Patel.</p>
      </div>
    </footer>
  );
}

export default FooterBlue;
